import _ from 'lodash';

export interface IHasEmail {
  email: string;
}

// checks that the email field is not undefined or null.
// the email field **might** be an empty string.
export function hasEmail(obj: { email?: string | null }): obj is IHasEmail {
  return !_.isNil(obj.email);
}
